module.exports = __webpack_public_path__ + "img/teacher6.cbebb5e3.jpg";